import { UntypedFormGroup } from '@angular/forms';

export class FormGroup extends UntypedFormGroup {
	editing = false;
	submitted = false;
	// This is to allow to configure a form group to only return those raw form values that have changed ('dirty' in Angular terms)
	onlyDirtyFormControls: boolean;

	constructor(onlyDirtyFormControls = false, ...baseFormGroupProps) {
		// tslint:disable-next-line:ban-ts-ignore
		// @ts-ignore
		// The Typescript compiler did not like this, but this code is perfectly valid
		// The rest operator (...) will pass all the needed items to Angular's NgFormGroup class
		// when we call new FormGroup(true, {}) for example
		super(...baseFormGroupProps);
		this.onlyDirtyFormControls = onlyDirtyFormControls;
	}

	// tslint:disable:no-empty */
	// TODO type better--like this: onSubmit: (arg1: any) => Observable<void>;
	// istanbul ignore next */
	onReset: Function = () => {};
	onSubmit: Function = () => {};
}
